import type { ViewerProductPermissions } from '@hopdrive/feature-portal-products';

import type { NavPermissions } from '../layout/nav/resolveNavModel';

/** The composition's permission facts, filled from the grants the frame already resolved so
 * each FeatureName is read once and feeds both the nav and the product entries. This is the
 * dealer's half of the host contract: `@hopdrive/feature-portal-products` types on the four
 * facts below and never sees a `NavPermissions` or a grant name. */
export function toViewerPermissions(p: NavPermissions): ViewerProductPermissions {
  return {
    canPlanMoves: p.canPlanMoves,
    hasMobileServiceAccess: p.canViewMobileService,
    hasPartsDeliveryAccess: p.canViewPartsDelivery,
    hasAppraisalsAccess: p.canViewAppraisals,
  };
}
